module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "new-campaign-finish"
  }, [_c('p', {
    staticClass: "title-text mt-2"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.finish.title')))]), _vm._v(" "), _c('p', {
    staticClass: "body-text text-center mt-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('NewCampaignInitialData.finish.body'))
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "justify": "center",
      "align": "end"
    }
  }, [_c('v-btn', {
    staticClass: "submit-button",
    attrs: {
      "loading": _vm.loading,
      "color": "#0098E1"
    },
    on: {
      "click": function($event) {
        return _vm.finishOnboarding()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.finish.goToDashboard')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c16cc274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaigns/NewCampaignFinish.vue
// module id = 1744
// module chunks = 0